/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ResultSection from './ResultSection';
import OverallData from '../../data/components/OverallData';
import { useTheme } from 'styled-components';
const FormattedLangMessage = /*#__PURE__*/memo(({
  gradeType
}) => {
  const lang = window.I18N_MANUAL_LANG;
  const alt = lang !== 'en' ? '-ALT' : '';
  return /*#__PURE__*/_jsx("p", {
    className: "description",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `results.overall.description.${gradeType}${alt}`
    })
  });
});

const Title = ({
  gradeType
}) => {
  const theme = useTheme();

  switch (theme.name) {
    case 'halloween':
      {
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `results.overall.halloween.title.${gradeType}`
        });
      }

    default:
      {
        return theme.title || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `results.overall.title.${gradeType}`
        });
      }
  }
};

export default (({
  websiteGrade
}) => {
  const grade = websiteGrade.overallGrade;
  const overallData = new OverallData().init(grade);
  const gradeType = overallData.gradeType;
  return /*#__PURE__*/_jsxs(ResultSection, {
    gradeType: gradeType,
    children: [/*#__PURE__*/_jsx("p", {
      className: "title",
      children: /*#__PURE__*/_jsx(Title, {
        gradeType: gradeType
      })
    }), /*#__PURE__*/_jsx(FormattedLangMessage, {
      gradeType: gradeType
    })]
  });
});